import React from 'react';

const PasswordStrengthIndicator = ({ password }) => {
  const calculateStrength = (pwd) => {
    if (!pwd) return { score: 0, label: '', color: '' };
    
    let score = 0;
    
    if (pwd?.length >= 8) score++;
    if (pwd?.length >= 12) score++;
    if (/[a-z]/?.test(pwd) && /[A-Z]/?.test(pwd)) score++;
    if (/\d/?.test(pwd)) score++;
    if (/[^a-zA-Z0-9]/?.test(pwd)) score++;
    
    if (score <= 1) return { score: 1, label: 'Weak', color: 'bg-destructive' };
    if (score === 2) return { score: 2, label: 'Fair', color: 'bg-warning' };
    if (score === 3) return { score: 3, label: 'Good', color: 'bg-primary' };
    if (score >= 4) return { score: 4, label: 'Strong', color: 'bg-success' };
    
    return { score: 0, label: '', color: '' };
  };

  const strength = calculateStrength(password);

  if (!password) return null;

  return (
    <div className="mt-2">
      <div className="flex gap-1 mb-2">
        {[1, 2, 3, 4]?.map((level) => (
          <div
            key={level}
            className={`h-1 flex-1 rounded-full transition-all duration-250 ${
              level <= strength?.score ? strength?.color : 'bg-muted'
            }`}
          />
        ))}
      </div>
      <p className={`text-xs font-medium ${
        strength?.score === 1 ? 'text-destructive' :
        strength?.score === 2 ? 'text-warning' :
        strength?.score === 3 ? 'text-primary': 'text-success'
      }`}>
        Password strength: {strength?.label}
      </p>
    </div>
  );
};

export default PasswordStrengthIndicator;